import React from "react";

const Footer = () => {
  return (
      <footer className="footer">
        <a href="https://www.niks-co.com/" className="footer__link">Developed by NIKS.</a>
      </footer>
  );
};

export default Footer;
